<template>
  <v-row class="flex-column mt-6 pr-8">
    <v-col class="custom-panel">
      <v-row class="flex-column">
        <v-col class="custom-panel__header">
          Add License Manager
          <v-btn icon @click="$router.push('/license-manager')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-col>
        <v-form v-model="valid" class="form-right-view-lable">
          <v-col class="custom-form mt-5">
            <v-row no-gutters>
              <v-col sm="2"
                ><label class="custom-form__label">Name *</label></v-col
              >
              <v-col sm="8">
                <v-text-field v-model="name" :rules="nameRules" filled autofocus/>
              </v-col>
            </v-row>
            <v-row no-gutters style="padding-bottom:20px">
              <v-col sm="2"
                ><label class="custom-form__label">Email *</label></v-col
              >
              <v-col sm="8">
                <v-text-field v-model="email" :rules="emailRules" :error-messages="emailError"
                @input="clearEmailError()"/>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col sm="2"
                ><label class="custom-form__label">Role *</label></v-col
              >
              <v-col sm="8">
                <!-- <v-text-field filled v-model="role"></v-text-field> -->
                <v-select
                  v-model="role"
                  :item-text="(item) => item.role_name"
                  :items="roleList"
                  :item-value="(item) => item.id"
                  filled
                  append-icon="expand_more"
                  label="Select"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-center">
                <v-btn
                  :disabled="
                    !valid ||
                    name === null ||
                    email === null ||
                    role === null ||
                    name === '' ||
                    email === ''
                  "
                  depressed
                  :loading="saveBtnloading"
                  class="primary_btn small"
                  @click="addLicenceManager"
                  >Create</v-btn
                >
              </v-col>
            </v-row>
          </v-col>
        </v-form>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex';
import { storeActions } from '@/store/actions.constants';

export default {
  data: () => ({
    saveBtnloading: false,
    emailError:'',
    valid: false,
    name: null,
    email: null,
    role: null,
    roleList: [],
    text: '',
    licenseManagerObj: {},
    nameRules: [
      (v) => !!v?.trim() || 'Name required',
      (v) =>
        /^[A-Za-z ]{3,20}$/.test(v?.trim()) ||
          'Name should contain character only and length should be 3 to 20',
    ],
    emailRules: [
      (v) => !!v || 'Email required',
      (v) => /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(v) || 'Invalid email',
    ],
  }),
  async mounted() {
    let res = await this.getRoleList();

    this.roleList = res.data;
  },
  methods: {
    ...mapActions({
      createLicenseManager: 'addLicenseManager/addLicenseManager',
      getRoleList: 'addLicenseManager/getRoleList',
    }),
    clearEmailError(){
      console.log('Input event is triggered');
      this.emailError = '';
    },
    // getRoles() {
    // this.getRoleList
    //   .then((res) => {
    //     console.log(res);
    //     if (res.status === 200) {
    //       this.roleList = res.data.data;
    //     }
    //   })
    //   .catch((err) => {
    //     // Skip login until API and schema got finalise
    //     console.error(err);
    //   });
    // },
    async addLicenceManager() {
      this.saveBtnloading = true;
      // const licenseManagerObj = {
      //   name: this.name,
      //   email: this.email,
      //   roleId: this.role,
      //   customer_id: 1,
      // };
      // this.$store.dispatch(`users/${storeActions.loginAction}`, usrObj).then((res) => console.log(res))
    
      this.licenseManagerObj = await this.createLicenseManager({
        name: this.name.replace(/\s+/g,' ')?.trim(),
        email: this.email,
        roleId: this.role,
        customer_id: 1,
      });
      // .then((res) => {
      // console.log(res);
      if (this.licenseManagerObj.status === 200) {
        this.saveBtnloading = false;
        this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
          text: this.licenseManagerObj.data.message,
          timeout: 1000,
          color: 'success',
        });
        this.$router.push('/license-manager');
      } else {
        this.saveBtnloading=false;
        // this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
        //   text: this.licenseManagerObj.data.message,
        //   timeout: 3000,
        //   color: 'error',
        // });
        this.emailError = this.licenseManagerObj.data.message;
      }
      // })
      // .catch((err) => {

      //   // Skip login until API and schema got finalise
      //   // this.$router.push('/license-manager');
      //   this.text=this.res.data.message;
      //   console.error(err);
      // });
    },
  },
};
</script>
